import { type FC, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

import { Button, Link, Loading } from "src/components";
import { useBankIdCallbackMutation, useBankIdInitQuery } from "src/serverApi";
import { useTranslation } from "src/translations";
import { isEmpty } from "src/utils";
import { DO_BANK_ID_REDIRECT } from "../constants";
import { KYC_CHECKING_ROUTE, KYC_SELECTION_ROUTE } from "../utils";

const BANK_ID_STATE = "bank_id_state";

export const BankId: FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const bankIdCode = searchParams.get("code");
    const bankIdState = searchParams.get("state");

    const here = window.location.origin + window.location.pathname;

    const { data: loginData } = useBankIdInitQuery({
        redirectUri: here,
    });
    const [callback] = useBankIdCallbackMutation();

    useEffect(() => {
        // handle data returned from Bank iD (if any)
        if (!isEmpty(bankIdCode)) {
            if (sessionStorage.getItem(BANK_ID_STATE) === bankIdState) {
                sessionStorage.removeItem(BANK_ID_STATE);
                callback({
                    code: bankIdCode,
                    redirectUri: here,
                });
                navigate(KYC_CHECKING_ROUTE);
            }
            return;
        }

        // no data from Bank iD yet, redirect to the login page but only once…
        if (sessionStorage.getItem(DO_BANK_ID_REDIRECT)) {
            if (loginData != null) {
                sessionStorage.removeItem(DO_BANK_ID_REDIRECT);
                sessionStorage.setItem(BANK_ID_STATE, loginData.state);
                window.location.href = loginData.uri;
            }
        } else {
            // …otherwise the login has been probably canceled so go back to KYC selection
            navigate(KYC_SELECTION_ROUTE);
        }
    }, [loginData, bankIdCode, bankIdState, navigate, callback, here]);

    return (
        <div className="grid size-full items-center justify-center">
            <div className="mt-12 grid size-full items-center justify-center gap-8">
                <div className="md:w-[600px]">
                    <Link href={KYC_SELECTION_ROUTE}>← {t("verification.KYC.backToSelection")}</Link>
                    {loginData ? (
                        <div className="grid gap-8 p-4">
                            <div className="grid justify-items-center gap-4">
                                <Button
                                    kind="outline"
                                    className="w-full max-w-[310px]"
                                    onClick={() => {
                                        window.location.href = loginData.uri;
                                    }}
                                >
                                    {t("verification.KYC.bankId")}
                                </Button>
                            </div>
                        </div>
                    ) : (
                        <Loading />
                    )}
                </div>
            </div>
        </div>
    );
};
